
        'use strict';
        import { Injectable, Inject } from 'ng-metadata/core';
        import {StorageUtil} from "../infra/storageUtil.service";
        import {getBackendSystem} from "../appConfig/appConfigForward";
        const get = require('lodash/get');


        let jwtStorageKey = 'primoExploreJwt';
        let decodedToken;


        @Injectable()
        export class JwtUtilService {

            public backFromLoginIframe : boolean;

            constructor(@Inject('jwtHelper') private jwtHelper,
            private storageUtil: StorageUtil) {
                this.backFromLoginIframe = false;
            }
            //let service = {
            //    // Add your functions here
            //    getJwtFromLocalStorage: getJwtFromLocalStorage,
            //    storeJwt: storeJwt,
            //    removeJwt: removeJwt
            //
            //};
            //return service;

           public isTokenExpired(jwt) {
                return this.jwtHelper.isTokenExpired(jwt);
            }
            public getDecodedToken() {
                if (!decodedToken) {
                    let jwt = this.getJwtFromLocalStorage();
                    if (!jwt) {
                        return {};
                    }
                    try{
                        decodedToken = this.jwtHelper.decodeToken(jwt);
                    }
                    catch(error) {
                        this.removeJwt();
                        return {};
                    }

                }
                return decodedToken;

            }

            public storeJwt(jwt) {
                this.storageUtil.sessionStorage.setItem(jwtStorageKey, jwt);
                decodedToken = '';
            }

            public getJwtFromLocalStorage() {
                let key= this.storageUtil.sessionStorage.getItem(jwtStorageKey);
                return key;
            }

            public removeJwt() {
                this.storageUtil.sessionStorage.removeItem(jwtStorageKey);
                decodedToken = '';
            }


            public getPdsHandle(){
                let jwtClaim = this.getDecodedToken();
                return jwtClaim.jti || jwtClaim.cmjti || ''; //campusM
            }

            public getInstitutionCode(){
                let jwtClaim = this.getDecodedToken();
                return jwtClaim.institution || '';
            }

            public decodeJWT(jwt){
                return this.jwtHelper.decodeToken(jwt);
            }

            public isGuest(){
                return !this.isSignedIn();
            }

            public isSignedIn(){
                const decodedToken = this.getDecodedToken();
                if (getBackendSystem() === 'suprima'){
                    return get(decodedToken, 'signedIn', false);
                }
                return get(decodedToken, 'userGroup', 'GUEST') !== 'GUEST';
            }

            public isSelfRegistered() {
                return this.getDecodedToken().selfRegistered === 'true';
            }


        }





// WEBPACK FOOTER //
// ./src/main/webapp/components/security/jwtUtil.service.ts